import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { motion } from 'framer-motion'

import styles from './SplashPage.module.scss'

const SplashPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      navigate('/')
    }, 1700)
  }, [])

  return (
    <div className={styles.main}>
      <motion.h1
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className={styles.title}
      >
        Stars Bank
      </motion.h1>
    </div>
  )
}

export default SplashPage
